import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { lifecycle, nest, compose } from 'recompose'
import { Flex, Box } from 'reflexbox'
import injectSagas from 'helpers/injectSagas'

import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'

import Actions from './Actions'
import Card from './Card'
import CardHeader from 'components/custom/Card/CardHeader'
import Divider from 'components/fulcrum/divider/Divider'
import FileList from 'components/fulcrum/fileSection/index'
import Header from './Header'
import Section from 'components/custom/Section/Section'
import FileUploadDialog from 'containers/Project/FileUploadDialog/index'
import FileRenameDialog from 'containers/Project/FileRenameDialog/index'
import FileDescriptionRenameDialog from 'containers/Project/FileDescriptionRenameDialog/index'
import FilePreview from 'containers/Project/FilePreview'

import sagas from './sagas'

import {
  MODULE_NAME,
} from './constants'

import {
  fetchProjectFiles,
  postFileRemove,
  fetchFile,
  fetchFileForPreview,
  patchFileInternal
} from './actions'

import {
  mount as fileRenameMount
} from 'containers/Project/FileRenameDialog/actions'

import {
  mount as descriptionRenameMount
} from 'containers/Project/FileDescriptionRenameDialog/actions'

import {
  setActive
} from 'containers/Project/FileUploadDialog/actions'

import {
  filteredFileSelector
} from './selectors'

import { 
  updatePreviewShow 
} from 'containers/Project/FilePreview/actions'

import {
  clearThumbnailLinks
} from 'containers/Project/Thumbnail/actions'

const mapStateToProps = (state) => {
  return {
    files: filteredFileSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddClick: () => dispatch(setActive()),
    fetchFiles: (id) => dispatch(fetchProjectFiles(id)),
    clearThumbnails: () => dispatch(clearThumbnailLinks()),
    onRename: (id) => dispatch(fileRenameMount(id)),
    onRenameDescription: (id) => dispatch(descriptionRenameMount(id)),
    onRemove: (id) => dispatch(postFileRemove(id)),
    onDownload: (id, name) => dispatch(fetchFile(id, name)),
    fetchFileForPreview: (id, name) => dispatch(fetchFileForPreview(id, name)),
    openPreview: () => dispatch(updatePreviewShow(true)),
    onInternal: (id, internal) => dispatch(patchFileInternal(id, internal)),
  }
}
class FileCard extends Component {

  onPreview(id, name){
    this.props.fetchFileForPreview(id, name)
    this.props.openPreview()
  }

  render(){
    const {
      collapse,
      toggleCollapse,
      onAddClick,
      files,
      onRename,
      onRenameDescription,
      onRemove,
      onDownload,
      onInternal
    } = this.props

    return (
      <Card>
        <CardHeader title='Attachments'>
          <Actions
            onAddClick={onAddClick}
            collapse={collapse}
            toggleCollapse={toggleCollapse}
          />
        </CardHeader>
        <Collapse collapse={collapse}>
          <Divider/>
          <Header/>
          <FileList
            onInternal={onInternal}
            onPreview={(id, name) => this.onPreview(id, name)}
            onDownload={onDownload}
            onRemove={onRemove}
            onRename={onRename}
            onRenameDescription={onRenameDescription}
            files={files}
          />
          <FileRenameDialog/>
          <FileDescriptionRenameDialog/>
          <FileUploadDialog/>
          <FilePreview/>
        </Collapse>
      </Card>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})

const FileSection = nest(Section, FileCard)

const enhance = compose(
  withSagas,
  withRouter,
  withConnect,
  withCollapse,
  lifecycle({
    componentDidMount() {
      const {fetchFiles, clearThumbnails, match} = this.props
      clearThumbnails()
      fetchFiles(match.params.id)
    }
  })
)

export default enhance(FileSection)
